<script>
  import RangeSlider from "svelte-range-slider-pips"
  import preferences from '../preferences'
  import SidebarArea from "./SidebarArea.svelte";

  const pref = preferences('adsbRange', [0, 50000])
</script>

<SidebarArea title='Altitude Filter'>
  <RangeSlider id="adsbRange" range bind:values={$pref} float suffix=" ft" min={0} max={50000} />
  <div class='altitudeOption'>
    <div>Min:</div><input type='number' bind:value={$pref[0]} />
    <div>Max:</div><input type='number' bind:value={$pref[1]} />
  </div>
</SidebarArea>

<style>
  .altitudeOption {
    display:grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: 4px;
  }

  input {
    margin:0;
  }

	:global(#adsbRange) {
		--range-handle-focus: rgb(42, 113, 245);
	}
</style>